// Part 1
import { createSlice } from "@reduxjs/toolkit"

// Part 2
export interface RateMaintenanceInitialState {
  openCloneRateModal: boolean;
}

const initialState: RateMaintenanceInitialState = {
  openCloneRateModal: false
}

// Part 3
export const rateMaintenanceSlice = createSlice({
  name: 'rateMaintenance',
  initialState,
  reducers: {
    setOpenCloneRateModal: (state, action) => {
      state.openCloneRateModal = action.payload
    },
    setCloseCloneRateModal: (state, action) => {
      state.openCloneRateModal = action.payload
    },
  }
})

// Part 4
export const { setOpenCloneRateModal, setCloseCloneRateModal } = rateMaintenanceSlice.actions
export default rateMaintenanceSlice.reducer
